import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  NewOrderDialogPaper: {
    borderRadius: theme.spacing(1)
  },
  NewOrderDialogClose: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
    color: theme.palette.grey[500]
  },
  NewOrderDialogContent: {
    position: 'relative',
    paddingBottom: theme.spacing(0)
  },
  NewOrderDialogFooter: {
    padding: theme.spacing(2, 4, 4, 4),
    justifyContent: 'flex-start'
  },
  DialogTitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 500,
    marginTop: 0,
    marginBottom: theme.spacing(1)
  }
}))
